import React from "react";
import {
    WORDPRESS_URL,
} from "../settings";

interface IWordpressMenuItem {
    attr: string;
    children?: IWordpressMenuItem[];
    classes: string;
    id: number;
    object: string;
    object_id: number;
    object_slug: string;
    order: number;
    parent: number;
    target: string;
    title: string;
    type: string;
    type_label: string;
    url: string;
    xfn: string;
}

interface IWordpressMenuResponse {
    count: number;
    description: string;
    ID: number;
    items: IWordpressMenuItem[];
    meta: {
        links: {
            [key: string]: string | undefined;
        };
    };
    name: string;
    slug: string;
}

interface IProps {
    alternateContent?: JSX.Element;
    id: string | number;
    loadingContent?: JSX.Element;
    renderSubmenus?: boolean;
}

interface IState {
    items: IWordpressMenuItem[];
    loading: boolean;
}

export default class EmbedWordpress extends React.Component<IProps, IState> {
    public state: IState = {
        items: [],
        loading: true,
    };

    /**
     * Fetch the initial API data and use it.
     */
    public componentDidMount(): void {
        const { id } = this.props;
        const url = `${ WORDPRESS_URL }wp-json/wp-api-menus/v2/menus/${ id }/`;
        this.fetchWordpressData(url);
    }

    /**
     * Render the HTML structure using recursive function.
     */
    public render(): JSX.Element | null {
        const {
            alternateContent,
            loadingContent,
        } = this.props;
        const {
            items,
            loading,
        } = this.state;

        if (loading) {
            if (loadingContent) {
                return loadingContent;
            }
        } else {
            if (items.length === 0 && alternateContent) {
                return alternateContent;
            }
        }

        return (
            <div>
                { this.renderItems(items) }
            </div>
        );
    }

    /**
     * Convert URLs from being relative to being absolute to the blog.
     *
     * @param url The URL which may be relative or full
     * @returns The converted URL
     */
    protected cleanUrl(url: string): string {
        if (!url) {
            return "";
        }

        if (url[0] === "/") {
            return `${ WORDPRESS_URL }${ url.slice(1) }`;
        }

        return url;
    }

    /**
     * Fetch the data from the WordPress API and process its items
     *
     * @param url The wordpress API endpoint
     */
    protected async fetchWordpressData(url: string): Promise<void> {
        const response = await fetch(url, {
            credentials: "include",
            method: "GET",
            mode: "cors",
        });

        const data = (await response.json()) as IWordpressMenuResponse;
        if (!data) {
            return;
        }

        const { items } = data;

        this.setState({
            items,
            loading: false,
        });

    }

    /**
     * Recursive function for generating menu and submenus.
     *
     * @param items WordPress menu items
     * @returns JSX elements of the menu
     */
    protected renderItems(items: IWordpressMenuItem[]): JSX.Element {
        const { renderSubmenus } = this.props;
        return (
            <ul>
                { items.map((item: IWordpressMenuItem): JSX.Element => {
                    return (
                        <li key={ item.id }>
                            <a href={ this.cleanUrl(item.url) }>{ item.title }</a>
                            { (renderSubmenus && item.children) ? (
                                this.renderItems(item.children)
                            ) : undefined }
                        </li>
                    );
                }) }
            </ul>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/EmbedWordpressMenu.tsx